interface EmailData {
  nome: string;
  email: string;
  telefone?: string;
  assunto: string;
  veiculo?: string;
  ano?: string;
  mensagem: string;
}

export function openEmailClient(data: EmailData): boolean {
  try {
    // Validar campos obrigatórios
    if (!data.nome || !data.email || !data.assunto || !data.mensagem) {
      return false;
    }

    // Detectar se é mobile
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    // Construir o corpo do email
    const emailBody = 
      `Olá,\n\n` +
      `Uma mensagem via site GZ Parts:\n\n` +
      `Nome: ${data.nome}\n` +
      `Telefone: ${data.telefone || 'Não informado'}\n` +
      `Assunto: ${data.assunto}\n` +
      `${data.veiculo ? `Veículo: ${data.veiculo}\n` : ''}` +
      `${data.ano ? `Ano: ${data.ano}\n` : ''}` +
      `${data.mensagem}\n\n`;

    // Para mobile, usar mailto:// (abre cliente nativo)
    if (isMobile) {
      const mailtoURL = `mailto:comercial@globalzeit.com.br?subject=${encodeURIComponent(`Novo Contato: ${data.assunto}`)}&body=${encodeURIComponent(emailBody)}`;
      window.open(mailtoURL, '_blank');
    } else {
      // Para desktop, abrir Gmail web com compose
      // Usar o endpoint correto do Gmail que abre o compose
      const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=comercial@globalzeit.com.br&su=${encodeURIComponent(`Novo Contato: ${data.assunto}`)}&body=${encodeURIComponent(emailBody)}`;
      window.open(gmailComposeUrl, '_blank');
    }

    return true;
  } catch (error) {
    console.error('Erro ao abrir cliente de email:', error);
    return false;
  }
}
